import ContainerStore from "app/list/ContainerStore"
import { debounce } from "lodash"
import { observable, decorate, action } from "mobx"
import { createContext } from "react"
import ApiClient from "utils/ApiClient"
import ShareStore from "./Share/ShareStore"
import React from "react";
import autoBind from "auto-bind"
import Moment from "moment"
import { handleSocketConnection } from "app/websocketManager/eventEmitter";

class PackStore {
    icon = "7"
    packName = "Pack Name"
    themeColor = "#237ff4"
    selectedSheetIndex = 0
    isSheetCreating = false
    containerStores = {}
    lastCreatedSheetId = ""
    isNewlyCreatedSheet = false

    constructor(appStore) {
        this.appStore = appStore;
        this.shareStore = new ShareStore(appStore, this);
        autoBind(this);
    }

    get lists() {
        return this.appStore.leftHoverMenuStore.packLists;
    }

    get isListsLoading() {
        return this.appStore.leftHoverMenuStore.isPackListsLoading;
    }

    reorderSheet(startIndex, hoverIndex) {
        const packLists = [...this.appStore.leftHoverMenuStore.packLists];
        packLists.splice(hoverIndex, 0, ...packLists.splice(startIndex, 1));

        this.appStore.leftHoverMenuStore.packLists = packLists;
    }

    get isAdmin() {
        return this.pack?.is_admin || false;
    }

    getCurrentContainerStore(listId = this.listId) {
        if (!listId) {
            return;
        }
        this.containerStores[listId] = this.containerStores[listId] ?? new ContainerStore(this);

        // this.appStore.containerStore = this.containerStores[listId]; //TODO: remove this
        return this.containerStores[listId];
    }

    handlePackIdChange = async id => {
        if (id == this.id) {
            return;
        }
        this.id = id;
        this.setPackToWindow();
        this.shareStore = new ShareStore(this.appStore, this);
        await this.appStore.leftHoverMenuStore.loadPackLists(id);
        if (this.lists.length === 1 && (Moment(this.lists[0].updated_at) - Moment(this.lists[0].created_at) < 3000) && this.lists[0].name.startsWith("Untitled")) {
            this.lastCreatedSheetId = this.lists[0]?.id;
        }
    }

    goToHomePage = () => {
        this.appStore.goToHomePage();
    }

    get pack() {
        if (!this.id) {
            return { name: "Pack Name" }
        }
        return this.appStore.leftHoverMenuStore.packs.find(pack => pack.id == this.id);
    }

    get isValidPack() {
        return this.appStore.leftHoverMenuStore.packs.length === 0 || this.pack;
    }

    // get packName() {

    // }

    setPackToWindow() {
        window.PACK = this.pack;
        this.setPackDetails()
    }

    setPackDetails() {
        this.packName = this.pack?.name ?? "";
        this.icon = this.pack?.icon ?? "";
        this.themeColor = this.pack?.color || this.themeColor;
    }


    openFirstSheet() {
        if (this.lists.length > 0) {
            this.appStore.routerHistory.replace(`/pack/${this.id}/list/${this.lists[0].id}`);
            handleSocketConnection(this.lists[0].id);
        }
    }

    handleCurrentListIdChange = listId => this.listId = listId;
    handlePackNameChange = async (packName) => {
        this.packName = packName;
        this.isModified = true;
        this.savePackDetailsDebounced();
    }

    handleMarkasDefaultReport = async (viewId) => {
        try {
            const response = await ApiClient.List.markAsDefaultReport(
                viewId
            );
        } catch (e) {
            console.log(e);
        }
    }

    handleThemeColorChange = themeColor => {
        this.themeColor = themeColor;
        this.isModified = true;
        this.savePackDetails();
    }

    handleIconChange = icon => {
        this.icon = icon
        this.isModified = true;
        this.savePackDetails();
    }

    handleChangeSheet = sheet => {
        this.appStore.routerHistory.push(`/pack/${this.id}/list/${sheet.id}`);
        handleSocketConnection(sheet.id);
        if (this.appStore.containerStores?.[sheet.id] != undefined) {
            let gridId = this.appStore.containerStores?.[sheet.id]?.currentViewStore?.gridId;
            if (gridId) {
                let parentDom = document.getElementById(gridId);
                if (parentDom != null) {
                    window.setTimeout(() => {
                        if (parentDom.querySelector(".ag-cell-focus")) {
                            parentDom.querySelector(".ag-cell-focus").focus();
                        }
                    }, 0)
                }
            }
        }
    }
    handleCreateSheet = async () => {
        if (this.isSheetCreating) {
            return;
        }

        this.isSheetCreating = true;
        const resp = await this.appStore.createSheet();
        if (!resp) {
            this.isSheetCreating = false;
            return;
        }
        await this.addSheetToPack(resp.data.id, this.id);
        this.isSheetCreating = false;
        handleSocketConnection(resp.data.id);
    }
    handleRenameSheet = async (value, selectedSheet) => {
        this.appStore.currentViewStore.isTabNameChanging = true;
        await this.appStore.leftHoverMenuStore.handleRenameSheet(
            value,
            selectedSheet
        );
        await this.appStore.containerStore.fetchInitialData(true, true);
        this.appStore.currentViewStore.isTabNameChanging = false;
    }

    addSheetToPack = async (listId, packId) => {
        try {
            const response = await ApiClient.Packs.addSheet({
                list_id: listId,
                pack_id: packId
            });
            const sheetData = response.data;
            this.isNewlyCreatedSheet = true;
            this.lastCreatedSheetId = sheetData.id;
            this.appStore.leftHoverMenuStore.packLists = [...this.appStore.leftHoverMenuStore.packLists, sheetData];
            if(response.success && sheetData.is_log_sheet == '0' && sheetData.parent_list_id == '0' && this.appStore?.allUserLists && Array.isArray(this.appStore.allUserLists) && this.appStore.allUserLists.length > 0) {
                this.appStore.allUserLists = [...this.appStore.allUserLists, sheetData];
            }
            this.appStore.routerHistory.push(`/pack/${this.id}/list/${sheetData.id}`);
        } catch (e) {
            const response = e.response;
            Ext.Msg.alert('', response?.messages || response?.message || "something went wrong");
        }
    }

    clearLastCreatedSheetId() {
        this.lastCreatedSheetId = ""
    }

    openLogSheet = async (sheet, pack_id) => {
        try {
            if (sheet.is_log_sheet != 1) {
                if (sheet.log_sheet_id) {
                    let logSheet = this.appStore.leftHoverMenuStore.packLists.filter(el => el.id == sheet.log_sheet_id);
                    if (logSheet.length == 0) {
                        logSheet = await ApiClient.List.getListConfig({ list_id: sheet.log_sheet_id });
                        this.appStore.leftHoverMenuStore.packLists = [...this.appStore.leftHoverMenuStore.packLists, logSheet.data.list];
                    }
                    this.appStore.routerHistory.push(`/pack/${pack_id}/list/${sheet.log_sheet_id}`)
                } else {
                    let item = await ApiClient.List.getListConfig({ list_id: sheet.id })
                    if (item.data?.list?.log_sheet_id) {
                        let logSheet = await ApiClient.List.getListConfig({ list_id: item.data.list.log_sheet_id });
                        let ispresent = this.appStore.leftHoverMenuStore.packLists.filter(el => el.id == logSheet.data.list.id);
                        if(ispresent.length == 0){
                            this.appStore.leftHoverMenuStore.packLists = [...this.appStore.leftHoverMenuStore.packLists, logSheet.data.list];
                        }
                        this.appStore.routerHistory.push(`/pack/${pack_id}/list/${logSheet.data.list.id}`)
                    } else {
                        window.appStore.notificationStore.showNotification('Log sheet not found', "error")
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    handleDeleteSheet = async (sheet, index) => {
        try {
            await this.appStore.notificationStore.confirm({
                description: (
                    <>
                        <div>This action will permanently delete the sheet</div>
                        <br />
                        <div><input type="checkbox" id={"should_send_email_" + sheet.id} /> Send email notification to all the shared users </div>
                    </>
                ),
            });
        } catch (e) {
            return;
        }
        this.appStore.currentViewStore.isSheetDeleting = true;
        let shouldSendEmail = Ext.get("should_send_email_" + sheet.id).getAttribute(
            "checked"
        );

        try {
            await ApiClient.Packs.deleteItem({
                item_id: sheet.id,
                should_send_email: shouldSendEmail ? 1 : 0,
            });
            this.appStore.notificationStore.showNotification(
                "Sheet deleted succcessfully",
                "success"
            );
            this.appStore.leftHoverMenuStore.packLists.splice(index, 1);
            if(this.appStore?.allUserLists && Array.isArray(this.appStore.allUserLists) && this.appStore.allUserLists.length > 0) {
                const userListIndex = this.appStore.allUserLists.findIndex((data) => data.id == sheet.id);
                if(userListIndex != -1) {
                    this.appStore.allUserLists.splice(userListIndex, 1);
                }
            }
            if (index != 0) {
                this.appStore.routerHistory.push(
                    `/pack/${this.id}/list/${this.appStore.leftHoverMenuStore.packLists[index - 1].id
                    }`
                );
            } else if (
                index == 0 &&
                this.appStore.leftHoverMenuStore.packLists.length > 0
            ) {
                this.appStore.routerHistory.push(
                    `/pack/${this.id}/list/${this.appStore.leftHoverMenuStore.packLists[0].id}`
                );
            } else if (this.appStore.leftHoverMenuStore.packLists.length === 0) {
                this.appStore.notificationStore.showNotification(
                    "No Lists in pack",
                    "error"
                );
                this.appStore.routerHistory.push(
                    `/pack/${this.id}`
                );
            }
            this.appStore.currentViewStore.isSheetDeleting = false;
        } catch (e) {
            Ext.Msg.alert("", e.response?.messages ? e.response?.messages : "Something went wrong please try again");
            this.appStore.currentViewStore.isSheetDeleting = false;
        }
    };

    handleDuplicateSheet = async (packId, sheetData, options=[], dataOptions = {}) => {
        try {
            let sheetOptions = {};
            if(options.length > 0){
                options.forEach(option=>sheetOptions[option.name] = option.selected);
            }
            const resp = await ApiClient.Packs.duplicateSheet({
                pack_id: packId,
                list_id: sheetData.id,
                sheet_options: sheetOptions,
                recordsOptions: dataOptions
            });

            if(resp.success && resp.data && resp.data.newlistId && resp.data.sheetData) {
                const {data : {newlistId}} = resp;                
                const {sheetData} = resp.data;
                if(newlistId && newlistId > 0) {
                    const {errorMessage} = resp.data;
                    if(errorMessage && Array.isArray(errorMessage) && errorMessage.length != 0){
                        let errorsSet = [ ...(new Set(errorMessage))];
                        this.appStore.notificationStore.showNotification(
                            `Sheet duplicated, but there ${errorsSet.length == 1 ? 'was a problem' : 'were problems'} ${errorsSet.join(", ")}`,
                            "warning"
                            );
                    }
                    else{
                        this.appStore.notificationStore.showNotification(
                            "Sheet duplicated successfully",
                            "success"
                            );
                    }
                    this.appStore.leftHoverMenuStore.packLists = [...this.appStore.leftHoverMenuStore.packLists, sheetData];
                    if(sheetData.is_log_sheet == '0' && sheetData.parent_list_id == '0' && this.appStore?.allUserLists && Array.isArray(this.appStore.allUserLists) && this.appStore.allUserLists.length > 0) {
                        this.appStore.allUserLists = [...this.appStore.allUserLists, sheetData];
                    }
                    this.appStore.routerHistory.push(`/pack/${packId}/list/${newlistId}`);
                }
                else {
                        this.appStore.notificationStore.showNotification(
                            "Something went wrong",
                            "error"
                            );
                    }
            }
            else if(resp.success && resp.data && !resp.newlistId && resp.data.errorMessage) {
                const {errorMessage} = resp.data;
                this.appStore.notificationStore.showNotification(
                    errorMessage,
                    "error"
                    );
            }
            else {
                if(!resp.success) {
                    let errorMessage = resp?.messages ? resp?.messages : resp?.msg ? resp?.msg : "Something went wrong, Please refresh the page";
                    this.appStore.notificationStore.showNotification(
                        errorMessage,
                        "error"
                        );
                }
            }
        } catch(e) {
            let resp = e.response;
            let errorMessage = resp?.messages ? resp?.messages : resp?.msg ? resp?.msg : "Something went wrong, Please refresh the page";
            this.appStore.notificationStore.showNotification(
                errorMessage,
                "error"
                );
        }
    }

    async saveSheetOrder() {
        try {
            this.isSaving = true;
            await ApiClient.Packs.changeSheetsOrder({
                pack_id: this.id,
                lists: this.lists.map(l => l.id).join(","),
            });
            this.isModified = false;
        }
        catch (e) {
            console.log(e);
        }
        this.isSaving = false;
    }

    savePackDetailsDebounced = debounce(this.savePackDetails, 1000)
    async savePackDetails() {
        try {
            this.isSaving = true;
            this.pack.name = this.packName;
            this.pack.color = this.themeColor;
            this.pack.icon = this.icon;
            const resp = await ApiClient.Packs.savePack({
                id: this.id,
                name: this.packName,
                color: this.themeColor,
                icon: this.icon,
            });
            // Object.keys(resp.data).forEach(x => this.pack[x] = resp.data[x]);
            this.isModified = false;
        }
        catch (e) {
            console.log(e);
        }
        this.isSaving = false;
    }

    exportPack(packInfo) {
        if (!packInfo) {
            packInfo = this.pack;
        }
      
        // let lists = packInfo?.store?.lists
        //   ?.filter((listsInfo) => listsInfo?.is_log_sheet === "0")
        //   .map((listsInfo) => listsInfo.id)
        //   .join(",");
        
        let lists = "";
        if(packInfo.lists && Array.isArray(packInfo.lists) && packInfo.lists.length > 0) {
            lists = packInfo?.lists.join(",");
        }
      
        let pack = {
          created_at: packInfo?.created_at,
          created_by: packInfo?.created_by,
          description: packInfo?.description,
          icon: packInfo?.icon,
          color: packInfo?.color,
          id: packInfo?.id,
          is_log_pack: packInfo?.is_log_pack,
          lists: lists,
          name: packInfo?.name,
          updated_at: packInfo?.updated_at,
        };
      
        if (this.createPackWindow) {
          this.createPackWindow.destroy();
        }
      
        this.importForm = Ext.create("TL.packs.templates.export.ExportPanel", {
          autoHeight: true,
          border: false,
          listData: {},
          pack: pack,
          listeners: {
            success: Ext.bind(function () {
            //   this.store.load();
              this.createPackWindow.close();
            }, this),
            close: Ext.bind(function () {
              this.createPackWindow.close();
            }, this),
            scope: this,
          },
        });
      
        this.createPackWindow = Ext.create("TL.Window", {
          width: 800,
          title: "Export Pack",
          cls: "tl-window export-template-win",
          border: false,
          autoScroll: true,
          items: [this.importForm],
        });
      
        this.createPackWindow.show();
    }      

    async deletePack() {
        try {
            await this.appStore.notificationStore.confirm({
                description: (
                    <>
                        This action will permanently delete the pack
                    </>
                ),
            });
        } catch (e) {
            return;
        }

        try {
            await ApiClient.Packs.deletePack({
                id: this.id
            });
            Ext.Msg.alert("Success", "Pack deleted succcessfully");
            this.appStore.routerHistory.push("/");
            this.appStore.leftHoverMenuStore.removePack(this.id);
        } catch (e) {
            Ext.Msg.alert("Error", e.response?.messages || "Something went wrong please try again");
        }
    }
}

decorate(PackStore, {
    id: observable,
    listId: observable,
    icon: observable,
    packName: observable,
    themeColor: observable,
    selectedSheetIndex: observable,
    isSheetCreating: observable,
    lastCreatedSheetId: observable,
    isNewlyCreatedSheet: observable,
    shareStore: observable,

    reorderSheet: action,
    handleRenameSheet: action,
    handleMarkasDefaultReport: action,
})

export default PackStore;
export const PackStoreContext = createContext();